import { render, staticRenderFns } from "./EditWorkItemPage.vue?vue&type=template&id=47bd9d82&"
import script from "./EditWorkItemPage.vue?vue&type=script&lang=js&"
export * from "./EditWorkItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports